

declare global {
    interface Navigator { 
        hid?: WebHIDApi;
    }
}

export interface WebHIDDeviceFilter {
    vendorId?: number;
    productId?: number;
    usagePage?: number;
    usage?: number;
}

export interface WebHIDRequestDeviceOptions {
    filters: WebHIDDeviceFilter[];
}

export interface WebHIDApi extends EventTarget {
    getDevices(): Promise<WebHIDDevice[]>;
    requestDevice(options: WebHIDRequestDeviceOptions): Promise<WebHIDDevice[]>;
}

export interface WebHIDDevice extends EventTarget {
    readonly vendorId: number;
    readonly productId: number;
    readonly productName?: string;
    readonly opened: boolean;
    open(): Promise<void>;
    close?(): Promise<void>;
    sendReport?(reportId: number, data: BufferSource): Promise<void>;
}

export interface WebHIDInputReportEvent extends globalThis.Event {
    readonly reportId: number;
    readonly data: DataView;
    readonly device?: WebHIDDevice;
}

export interface WebHIDConnectionEvent extends globalThis.Event {
    readonly device: WebHIDDevice;
}

export function getWebHIDApi(target: Pick<Navigator, "hid">): WebHIDApi | undefined {
    return target.hid;
}

export function webHidDeviceKey(device: Pick<WebHIDDevice, "vendorId" | "productId" | "productName">): string {
    return `${device.vendorId}:${device.productId}:${device.productName ?? "unknown"}`;
}
